import React from 'react';
import { Swords } from 'lucide-react';

const Logo = ({ size = 56, className = "" }) => {
    return (
        <div className={`relative flex items-center justify-center ${className}`}>
            <div className="relative">
                <div
                    className="absolute inset-0 bg-gradient-to-br from-purple-600/20 to-purple-900/20 rounded-full blur-md"
                    style={{ width: size, height: size }}
                ></div>
                <img
                    src="/logo.jpg"
                    alt="FinAssure Logo"
                    className="relative object-cover rounded-full border border-purple-500/30 p-1"
                    style={{
                        width: size,
                        height: size,
                        filter: 'brightness(1.4) contrast(1.1) drop-shadow(0 0 20px rgba(168, 85, 247, 0.9))',
                        background: 'radial-gradient(circle, rgba(168, 85, 247, 0.15), transparent 70%)',
                    }}
                />
            </div>
        </div>
    );
};

export default Logo;
